import React from 'react';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

/**
 * App-wide safety net. If any render throws (a TDZ error, an unhandled error from a failed
 * request, etc.), this shows a recoverable message instead of leaving the user on a blank
 * white screen. Several bugs this session manifested as blank screens — this prevents that.
 */
class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary] Uncaught render error:', error, info);
  }

  handleReload = (): void => {
    window.location.reload();
  };

  render(): React.ReactNode {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            padding: 24,
            textAlign: 'center',
            fontFamily: 'sans-serif',
            color: '#333'
          }}
        >
          <h2>Ocurrió un error inesperado</h2>
          <p>Por favor, recargá la página o intentá de nuevo.</p>
          <button
            type="button"
            onClick={this.handleReload}
            style={{
              marginTop: 16,
              padding: '10px 24px',
              cursor: 'pointer',
              border: 'none',
              borderRadius: 6,
              background: '#5850EC',
              color: '#fff',
              fontSize: 15
            }}
          >
            Reintentar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
